module.exports = __webpack_public_path__ + "static/media/nav-my-profile.350397ee.svg";